import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    shouldAddStudioToFooter: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Show studio product in footer (In test don't touch)"
    }
  }
};
